import * as React from "react"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Logo from "../../images/portfolio-logo-black.png"
import { keyframes } from "@emotion/react"

const slide = keyframes`
0%  { opacity: 0 }
100% { opacity: 1 }
`;

const Header = ({ onClick, isMenuVisible }) => {
  return (
    <section>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          height: "60px",
        }}
      >
        <Box>
          <Button
            onClick={() => onClick()}
            disableRipple
            sx={{
              alignSelf: "flex-start",
              fontSize: "14px",
              fontFamily: "Josefin Sans",
              fontWeight: "800",
              color: "#000",
              letterSpacing: "1.1px",
              ":hover": {
                backgroundColor: "transparent",
              },
              position: "relative",
              left: "5px",
            }}
          >
            Menu
          </Button>
        </Box>

        {!isMenuVisible && (
          <Box
            component="img"
            sx={{
              opacity: "0",
              width: "120px",
              position: "relative",
              // top: '16px',
              right: "10px",
              animation: `${slide} 3s forwards`,
              animationDelay: "0.3s",
              // border: '1px solid brown'
            }}
            src={Logo}
            alt="portfolio image"
          ></Box>
        )}
      </Box>
    </section>
  )
}

export default Header;
